import React from "react"
import { usePageContext } from "vike-react/usePageContext"
import BlogPost from "../Blog/post"

const BlogPostPage = () => {
  const pageContext = usePageContext()

  const rawPathname = pageContext?.urlPathname || ''
  const pathname = rawPathname.replace(/^\/[a-z]{2}(\/|$)/, (_, sep) => sep || '/')
  const pathSegments = pathname.split('/').filter(Boolean)
  const postID = pathSegments[1]

  if (!postID) {
    return <div>Error: No post ID found in the URL.</div>
  }

  return <BlogPost postID={postID} />
}

export const onBeforeRender = async (pageContext) => {
  const rawRequestPath = pageContext.urlParsed?.pathname || pageContext.urlPathname || '/'
  const requestPath = rawRequestPath.replace(/^\/[a-z]{2}(\/|$)/, (_, sep) => sep || '/')

  const blogPostMatch = requestPath.match(/^\/blog\/(.+)$/)

  if (!blogPostMatch) {
    return {}
  }

  const slug = blogPostMatch[1]

  try {
    const { GetCMSContent } = await import('aldoo-ra/CMS/api')
    const { url } = await import('aldoo-ra/CMS/url')

    const response = await GetCMSContent({
      page: 1,
      itemsPerPage: 1,
      match: {
        'content.type': 'BlogPost',
        'content.slug': slug
      },
      expand: true
    })

    // answered, and no such post: the page is a 404 (pages/+onBeforeRender.js)
    if (response && !response.error && Array.isArray(response.data) && !response.data.length) {
      return { metadata: { notFound: true } }
    }

    if (response.data && response.data.length > 0) {
      const post = response.data[0].content

      const seoTitle = post.seo_title || post.title || 'Blog Post'
      const seoDescription = post.seo_description || post.title || 'Read our latest blog post'
      const seoImage = post.seo_image || post.thumbnail || '/static/images/og_image.jpg'
      const tags = Array.isArray(post.tags) ? post.tags.join(', ') : ''

      const { getCanonicalUrl } = await import('aldoo-ra/AldooVike/app')
      const canonicalUrl = getCanonicalUrl(pageContext)
      const image = url(seoImage) || seoImage
      const { blogPostingJsonLd } = await import('./seo.js')

      return {
        title: seoTitle,
        description: seoDescription,
        thumbnail: image,
        tags: tags,
        metadata: {
          ogType: 'article',
          ...(canonicalUrl && { canonicalUrl }),
          // a draft is reachable by its link but stays out of search
          ...(post.status === 'draft' && { robots: 'noindex, nofollow' }),
          jsonLd: blogPostingJsonLd({
            post: response.data[0],
            title: post.title || seoTitle,
            description: seoDescription,
            image,
            url: canonicalUrl,
          }),
        }
      }
    }
  } catch (error) {
    console.error('BlogPostPage onBeforeRender ERROR:', error)
  }

  return {}
}

BlogPostPage.onBeforeRender = onBeforeRender

export default BlogPostPage